(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["id-discover-latest-card"] && !Shopify.designMode) return;
  try {
    (function(){
  if(window.__idBscSwatch)return;window.__idBscSwatch=1;
  document.addEventListener('click',function(e){
    var s=e.target&&e.target.closest&&e.target.closest('.id-bsc__sw');
    if(!s)return;
    e.preventDefault();e.stopPropagation();
    var card=s.closest('.id-bsc__card');
    if(!card)return;
    var img=card.querySelector('.id-bsc__media img');
    if(img){
      if(s.getAttribute('data-sw-src'))img.setAttribute('src',s.getAttribute('data-sw-src'));
      if(s.getAttribute('data-sw-srcset'))img.setAttribute('srcset',s.getAttribute('data-sw-srcset'));
    }
    var u=s.getAttribute('data-sw-url');
    if(u)card.setAttribute('href',u);
    ['price','apple','monthly','deal','compare'].forEach(function(key){
      card.querySelectorAll('[data-card-'+key+']').forEach(function(el){el.textContent=s.getAttribute('data-'+key);});
    });
    card.querySelectorAll('[data-card-from]').forEach(function(el){el.hidden=true;});
    var sale=s.getAttribute('data-sale')==='true';
    card.querySelectorAll('[data-card-sale]').forEach(function(el){el.hidden=!sale;});
    var badge=card.querySelector('[data-card-badge]');
    if(badge){badge.hidden=!sale;badge.textContent='−'+s.getAttribute('data-off')+'%';}
    var sibs=s.parentNode.querySelectorAll('.id-bsc__sw');
    for(var i=0;i<sibs.length;i++)sibs[i].classList.remove('is-on');
    s.classList.add('is-on');
  });
})();
  } catch(e) { console.error(e); }
})();

})();
